import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import axios from "axios";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import KioskHeader from "../kiosk/component/common/kioskHeader";
import KioskFooter from "../kiosk/component/common/kioskFooter";
import KioskList from "../kiosk/component/common/kioskList";
import KioskTable from "../kiosk/component/common/kioskTable";
import EditStatusModal from "./component/kioskPickUp/editStatusModal";
import ReadyPickupModal from "./component/kioskPickUp/readyPickupModal";

import { Container } from "../kiosk/component/styled/common";
import { KioskPickUp } from "../kiosk/component/styled/pickUp";

import { formatText } from "../kiosk/component/function/kiosk";
import { useDisableScroll } from "../../../hooks/useDisableScroll";
import { checkKioskCond } from "../dashboard/component/function/dashboard";

const BbdabangPickUp = () => {
  useDisableScroll();

  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [origin, setOrigin] = useState([]);
  const [searched, setSearched] = useState("");
  const [selected, setSelected] = useState({});
  const [modalType, setModalType] = useState("");
  const [reqCount, setReqCount] = useState(0);

  const navigate = useNavigate();

  // const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const extractReserveItems = (responseData) => {
    if (Array.isArray(responseData)) {
      return responseData;
    }

    const items = responseData?.data?.items;
    return Array.isArray(items) ? items : [];
  };

  useEffect(() => {
    if (!checkKioskCond(company)) {
      toast.error("접근 권한이 없습니다.", { toastId: "no-access" });
      navigate("/mypage");
      return;
    }

    getEnableStorage();
    getReqCustomer();
  }, []);

  // 보관 중 조회
  const getEnableStorage = async () => {
    const url = "/api/reserve-user";
    const body = {
      reserveStatus: "COMPLETED",
      point: "baseball",
    };
    const res = await axios.post(url, body);

    if (res.status === 200) {
      const items = extractReserveItems(res.data);
      setOrigin(items);
      setData(items);
    }
  };

  // 검색
  const handleSearch = (flag = false) => {
    if (flag) {
      setData([...origin]);
    } else {
      const filteredData = origin.filter(
        (item) =>
          (item.mberNm && item.mberNm.includes(searched)) ||
          (item.tel && formatText(item.tel).includes(formatText(searched))),
      );

      setData(filteredData);
    }
  };

  const handleModalOpen = async (status, item = null) => {
    if (status === "COMPLETED") {
      setSelected(item);
    }

    setModalType(status);
    setOpenModal(true);
  };

  const handleModalClose = async () => {
    setOpenModal(false);
    setModalType("");
    await getEnableStorage();
  };

  // 픽업 요청 조회
  const getReqCustomer = async () => {
    const url = "/api/request-user";
    const body = { point: "baseball" };

    const res = await axios.post(url, body);
    const items = Array.isArray(res.data) ? res.data : [];
    const count = items.length;

    if (res.status === 200) setReqCount(count);
  };

  const getModalContent = () => {
    switch (modalType) {
      case "COMPLETED":
        return (
          <EditStatusModal
            selected={selected}
            handleModalClose={handleModalClose}
            // handleReserveCancel={handleReserveCancel}
          />
        );
      case "READY":
        return <ReadyPickupModal handleModalClose={handleModalClose} setReqCount={setReqCount} />;

      default:
        return null;
    }
  };

  return (
    <Container>
      <KioskPickUp className="baseball">
        <KioskHeader
          title={"찾기"}
          handleSearch={handleSearch}
          searched={searched}
          setSearched={setSearched}
        />
        <div className="content">
          <div className="pickupReqButton">
            <button className="pickupReqButton" onClick={() => handleModalOpen("READY")}>
              픽업요청확인{reqCount > 0 && ` (${reqCount})`}
            </button>
          </div>
          {isTablet ? (
            <KioskList data={data} type="pickup" handleModalOpen={handleModalOpen} />
          ) : (
            <KioskTable data={data} type="pickup" handleModalOpen={handleModalOpen} />
          )}
        </div>

        {openModal && getModalContent()}
        <KioskFooter />
      </KioskPickUp>
    </Container>
  );
};

export default BbdabangPickUp;
